import { toaster as globalToaster, useToaster, Message } from 'rsuite';
import i18n from '@app/i18n';

const TOAST_OPTIONS = {
  duration: 3000,
  placement: 'topEnd',
  mouseReset: false,
};

async function pushToast(toaster, type, text) {
  let key;
  key = await toaster.push(
    <Message showIcon type={type} closable onClick={() => toaster.remove(key)}>
      {text || (type === 'error' ? i18n.t('request_error') : '')}
    </Message>,
    TOAST_OPTIONS,
  );
}

export const useShowToaster = () => {
  const toaster = useToaster();

  return (type, text) => pushToast(toaster, type, text);
};

// showToaster вызывается вне компонентов (в thunk'ах), где хук useToaster недоступен.
// Глобальный toaster из rsuite для этого не подходит: он создаёт свой контейнер
// вне CustomProvider и передаёт опции тоста в <div>, из-за чего React ругается на mouseReset.
// Поэтому ToasterBridge (смонтирован в App.jsx внутри CustomProvider) сохраняет
// тостер из хука в appToaster, и showToaster показывает тосты через него —
// в тех же контейнерах, что и useShowToaster.
// Глобальный toaster остаётся запасным вариантом, пока ToasterBridge не смонтирован.
let appToaster = globalToaster;

export function ToasterBridge() {
  appToaster = useToaster();
  return null;
}

export const showToaster = (type, text) => pushToast(appToaster, type, text);
